import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as UtilityProviderIcon } from '../../assets/icons/sidebar/utility-icon.svg';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setPageTitle } from '../../redux/slices/PageTitleSlice';

import UtilityProviderList from './components/utility-provider-list';

/**
 * Account Management function Component
 */
function UtilityProvider() {
  const { t } = useTranslation('account');
  const dispatch = useAppDispatch();

  const {
    totalResults,
  } = useAppSelector((state) => state.utility);

  useEffect(() => {
    dispatch(setPageTitle({
      title: t('utilityProvider'),
      icon: <UtilityProviderIcon />,
      count: totalResults,
    }));
  }, [totalResults]);

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div className="container" >
        <div className="body-container">
          <div className="table-content">
            <UtilityProviderList />
          </div>
        </div>
      </div>
    </div>
  );
}

export default UtilityProvider;
